import React, { PureComponent } from 'react';
import Styles from '../constants/Styles';
import { MoxiCurrentActionView } from './DRViewUtils';
import { RobotTaskStatus } from '../vodjs/registry';

export default class CurrentStatusView extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let { item } = this.props;

    let robotIds = item.actionsAndStatuses ? Object.keys(item.actionsAndStatuses) : [];
    robotIds.sort();

    return (
      <div style={{ height: '100%', width: '100%', justifyContent: 'space-around' }}>
        {robotIds.map((rid) => {
          return (
            <MoxiCurrentActionView
              key={rid}
              moxiCurrentAction={item.actionsAndStatuses[rid].moxiCurrentAction}
              robotId={rid}
            />
          );
        })}
      </div>
    );
  }
}
